import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60cf39a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "basemap-container" }
const _hoisted_2 = { class: "basemap" }
const _hoisted_3 = { class: "basemap__header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "desc" }

import { storeToRefs } from 'pinia';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import 'swiper/swiper-bundle.css';
import { useWorkshop } from '@/store';
import { useBackgroundUrl } from '@/components/workshop/useWorkshopImg';


export default /*#__PURE__*/_defineComponent({
  __name: 'main',
  emits: ["slide"],
  setup(__props, { emit }: { emit: ({
  (e: 'slide', index: number): void;
}), expose: any, slots: any, attrs: any }) {

_useCssVars(_ctx => ({
  "7c7844e0": (_unref(thumbnailBg).mobile),
  "661ee958": (_unref(thumbnailBg).tablet),
  "92d968ac": (_unref(thumbnailBgActive).mobile),
  "7c800d24": (_unref(thumbnailBgActive).tablet),
  "50a4986e": (_unref(thumbnailMask).mobile),
  "3a4b3ce6": (_unref(thumbnailMask).tablet)
}))

const { basemapList, selectedBasemapIndex } = storeToRefs(useWorkshop());
const { thumbnailBg, thumbnailBgActive, thumbnailMask } = useBackgroundUrl();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t('IW_P4_BASEMAP')), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('IW_P4_BASEMAP_TIP')), 1)
      ]),
      _createVNode(_unref(Swiper), {
        class: "basemap__swiper",
        "slides-per-view": "auto",
        "space-between": 0,
        "resize-observer": true
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(basemapList), (item, index) => {
            return (_openBlock(), _createBlock(_unref(SwiperSlide), {
              key: index,
              onClick: ($event: any) => (emit('slide', index))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass([
              'thumbnail',
              { 'thumbnail--active': index === _unref(selectedBasemapIndex) },
            ])
                }, [
                  _createElementVNode("div", {
                    class: "thumbnail__img",
                    style: _normalizeStyle({ 'background-image': `url(${item})` })
                  }, null, 4)
                ], 2)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})